export default __webpack_public_path__ + "static/pragicts-ai-logistics-0d73612b4f0a8a4d5d6597634c5dfabb.jpg";